<script setup lang="ts">
import type { ISchoolGradeDisplayConfiguration } from '@/core/school-grades/schoolGrade.types';
import { PerformanceAssessmentDocumentationMode } from '@/api/generated/api.enum';
import type { Components } from '@/api/generated/api';
import PerformanceLevelRatingInput from '@/core/performance-visuals/PerformanceLevelRatingInput.vue';
import SchoolGradeInput from '@/core/school-grades/SchoolGradeInput.vue';
import { getAssessmentDocumentationMode } from 'common/utils/performance.assessment.utils';
import type { ISchoolGradeInputProps } from '@/core/school-grades/schoolGradeInput.types';

// modelValue is a numeric grade for SCHOOL_GRADE and a visual-level ID otherwise.
const props = defineProps<
  ISchoolGradeInputProps & {
    gradeConfiguration: ISchoolGradeDisplayConfiguration | null;
    assessment: Components.Schemas.BasePerformanceAssessmentDto;
  }
>();
const emit = defineEmits<{ 'update:modelValue': [value: number | null] }>();
const updateVisual = async (value: number | null): Promise<void> => {
  if (props.save) await props.save(value);
  else emit('update:modelValue', value);
};
</script>
<template>
  <SchoolGradeInput
    v-if="
      gradeConfiguration &&
      getAssessmentDocumentationMode(assessment) === PerformanceAssessmentDocumentationMode.SCHOOL_GRADE
    "
    :configuration="gradeConfiguration"
    :model-value="modelValue"
    :accessible-label="accessibleLabel"
    :disabled="disabled"
    :mode="mode"
    :save="save"
    @update:model-value="emit('update:modelValue', $event)"
  />
  <PerformanceLevelRatingInput
    v-else-if="getAssessmentDocumentationMode(assessment) !== PerformanceAssessmentDocumentationMode.SCHOOL_GRADE"
    :model-value="modelValue"
    :accessible-label="accessibleLabel"
    :disabled="disabled"
    :performance-visual="assessment.performanceVisual"
    :mode="mode"
    @update:model-value="updateVisual"
  />
</template>
